import { useCallback } from 'react';
import { useLazyGetRechargePaymentCodeQuery } from '../services/benefitApi';
export function useRechargePaymentCode() {
    const [trigger, result] = useLazyGetRechargePaymentCodeQuery();
    const fetchPaymentCode = useCallback(async (params) => {
        const response = await trigger(params);
        return response.data;
    }, [trigger]);
    return {
        paymentCode: result.data || null,
        isLoading: result.isLoading,
        isError: result.isError,
        isSuccess: result.isSuccess,
        fetchPaymentCode,
    };
}
